import React from "react";
import { OrderCsvImportError } from "api/sms-api";
import i18n from "i18n";
import { List } from "antd";

interface ImportErrorProps {
  error: OrderCsvImportError;
}

const ImportError: React.FC<ImportErrorProps> = (props) => {
  const description = i18n.t(
    `orders.csv.importErrorDescription.${props.error.errorType}`
  );
  return (
    <List.Item>
      {`${i18n.t("orders.csv.importErrorLine", {
        line: props.error.lineNumber,
      })}${description}`}
    </List.Item>
  );
};

export default ImportError;
